import React, { useState, useEffect } from 'react';
import { useNotificationsContext } from '../../../contexts/Notifications';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from './SnackbarContent';

const useStyles = makeStyles((theme: any) => ({
  snackbar: {
    '& .MuiSnackbarContent-message': { width: '100%' },
    '& .MuiSnackbarContent-root': {
      width: 550,
      backgroundColor: ({ type }: any) => {
        return type ? theme.palette.brand.greyLight : theme.palette.brand.dark;
      },
      color: ({ type }: any) => {
        return type ? 'black' : theme.palette.brand.greyLight;
      },
    },
  },
}));

export default function MySnackBar({
  handleClose,
  open,
  message,
  header,
  duration,
  type,
}) {
  const classes = useStyles({ type });
  const [notificationOpen, setNotificationOpen] = useState(false);
  const { notifications } = useNotificationsContext();

  useEffect(() => {
    setNotificationOpen(notifications?.length > 0 ? true : false);
  }, [notifications]);

  return (
    <Snackbar
      style={notificationOpen ? { bottom: 85 } : {}}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      message={
        <SnackbarContent
          header={header}
          message={message}
          type={type}
          handleClose={handleClose}
        />
      }
      className={classes.snackbar}
    />
  );
}
